module.exports = __webpack_public_path__ + "static/img/BILLY-WILSON.869d8d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BILLY-WILSON.jpg
// module id = ZUCx
// module chunks = 0